import { APIService } from "./api";
import { API } from "@/lib/api";
import { ReadProvince, WriteProvince } from "@/types/province";

export const ProvinceService = new APIService<ReadProvince, WriteProvince>(
  API.Provinces,
);
export const fetchProvinceList = ProvinceService.getList;
